module.exports = __webpack_public_path__ + "media/images/360/insomnia_moon_dark_skies-18d43c8aab62bc906db29264e69ac36e.webp";